<template lang="html">
  <div id="d-profile-page">

    <section class="short-info-section-s1">
      <div class="box-top">
        <div class="col-12 col-title">
          <h2>Ideas gente OZ</h2>
        </div>
      </div>
    </section>

    <section class="main-section">
      <b-form class="form" @submit="onSubmit">
        <div class="row justify-content-center">

          <!-- <div class="col-lg-8">
            <b-form-group class="mb-4 form-group-s1"
              label="Nombre completo">
              <b-form-input
                v-model="form.name"
                type="text"
                placeholder=""
                required
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-lg-8">
            <b-form-group class="mb-4 form-group-s1"
              label="Correo electrónico">
              <b-form-input
                v-model="form.email"
                type="email"
                placeholder=""
                required
              ></b-form-input>
            </b-form-group>
          </div> -->

          <div class="col-lg-8">
            <b-form-group class="mb-4 form-group-s1"
              label="Cuentanos tu idea">
              <b-form-textarea
                v-model="form.msg"
                placeholder=""
                rows="6"
                max-rows="6"
                required
              ></b-form-textarea>
            </b-form-group>
          </div>

          <div class="col-lg-8 mt-lg-4 text-center">
            <b-button type="submit" class="btn-s1 bg-red btn-lg btn-send">Enviar</b-button>
          </div>

        </div>
      </b-form>

      <sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block"  ref="modal">
          <div class="fa-3x" v-if="modal.icon== ''"><i class="fas fa-spinner fa-pulse"></i></div><br/>
          <div v-html="modal.msg"></div>
          
        </sweet-modal>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: null,
        email: null,
        msg: null,
      },
      modal:{
        msg:'',
        icon:'',
        block:false,
      },
    }
  },

  methods: {
    onSubmit(event) {
        event.preventDefault();
        this.modal.icon = "";
        this.modal.msg = 'Cargando...';
        this.modal.block = true;
        this.$refs.modal.open();
        this.form.users_id = this.$root.user.id;
        axios.post(tools.url("/api/mailboxes"),this.form).then((response)=>{
        
            this.modal.block = false;
            this.modal.icon = 'success';
            this.modal.msg = 'Información guardada correctamente';
		}).catch((error)=>{
            this.modal.block = false;
            this.modal.icon = 'error';
            this.modal.msg = error.response.data.msg;
		});

    },
  },
}
</script>
